import { _black, StyledSvg, SvgPropsType } from "../common/CommonSvg"

// 폴더 
export const SvgThermometer = (({$fillColor}:SvgPropsType ) => {
  return <StyledSvg $fillColor={$fillColor || _black }  viewBox="44 21 10 54" fill="none" enableBackground="new 0 0 96 96">
    <g>
      <g>
        <path d="M50,58.424V47c0-1.104-0.896-2-2-2c-1.105,0-2,0.896-2,2v11.424c-1.763,0.773-3,2.531-3,4.576c0,2.757,2.243,5,5,5
          c2.757,0,5-2.243,5-5C53,60.955,51.763,59.197,50,58.424z M48,64c-0.552,0-1-0.448-1-1s0.448-1,1-1c0.552,0,1,0.448,1,1
          S48.552,64,48,64z"/>
        <path d="M56.009,55.459L56,30c0-4.411-3.589-8-8-8c-4.411,0-8,3.589-8,7.999l-0.01,25.46C38.08,57.492,37,60.192,37,63
          c0,6.065,4.935,11,11,11c6.065,0,11-4.935,11-11C59,60.191,57.92,57.491,56.009,55.459z M48,70c-3.859,0-7-3.141-7-7
          c0-1.984,0.848-3.885,2.327-5.213c0.422-0.38,0.663-0.92,0.663-1.487L44,30c0-2.206,1.794-4,4-4c2.206,0,4,1.794,4,4.001
          L52.009,56.3c0,0.567,0.241,1.108,0.664,1.487C54.151,59.115,55,61.015,55,63C55,66.859,51.859,70,48,70z"/>
      </g>
    </g>
  </StyledSvg>
})
